import { RequestBuilder, fetchAndRetryIfServerBusy } from '@cvent/nucleus-networking';
import { SESSION_HEADER_EVENT_ID } from '../constants/Request';
import { ServiceError } from '../utils/errors';

/**
 * API client for communicating with the event site editor service.
 */
export default class AttendeeListClient {
  constructor(baseUrl, eventId, environment, authorizationToken, eventSnapshotVersion, accountSnapshotVersion) {
    this.baseUrl = `${baseUrl}attendee_list`;
    this.environment = environment;
    this.eventId = eventId;
    this.eventSnapshotVersion = eventSnapshotVersion;
    this.accountSnapshotVersion = accountSnapshotVersion;
    this.requestBuilder = new RequestBuilder({
      url: this.baseUrl
    })
      .auth(authorizationToken)
      .withCookies()
      .header(SESSION_HEADER_EVENT_ID, eventId);
  }

  /**
   * Create an Attendee List Search
   */
  createAttendeeSearch = async (searchValue, columns, filterObject, isDisplayGuests) => {
    let createSearchBody = {
      eventStub: this.eventId,
      searchValue,
      columns,
      isDisplayGuests
    };
    if (filterObject) {
      createSearchBody.filterEvaluationType = filterObject.filterEvaluationType;
      createSearchBody.filterCriteriaList = filterObject.filterCriteriaList;
    }
    const request = this.requestBuilder
      .url(`${this.baseUrl}/createsearch`)
      .query('environment', this.environment)
      .query('accountVersion', this.accountSnapshotVersion)
      .post()
      .json(createSearchBody)
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      throw await ServiceError.create('createAttendeeSearch failed', response, request);
    }
    const searchResponse = await response.json();
    return searchResponse.searchId;
  };

  /**
   * Get attendee information from created Search
   */
  getAttendeeSearch = async (searchId, searchObject) => {
    const getSearchBody = {
      eventStub: this.eventId,
      searchId,
      ...searchObject
    };
    const request = this.requestBuilder
      .query('environment', this.environment)
      .query('accountVersion', this.accountSnapshotVersion)
      .query('eventVersion', this.eventSnapshotVersion)
      .post()
      .json(getSearchBody)
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      throw await ServiceError.create('getAttendeeSearch failed', response, request);
    }
    const searchResponse = await response.json();
    return searchResponse;
  };

  getContactCustomFieldNames = async (listOfContactCustomFields) => {
    const request = this.requestBuilder
      .url(`${this.baseUrl}/getContactCustomFieldNames`)
      .query('environment', this.environment)
      .query('accountVersion', this.accountSnapshotVersion)
      .post()
      .json(listOfContactCustomFields)
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      throw await ServiceError.create('getContactCustomFieldNames failed', response, request);
    }
    const contactCustomFieldNames = await response.json();
    return contactCustomFieldNames;
  }

  getRegistrationTypeNames = async () => {
    const request = this.requestBuilder
      .url(`${this.baseUrl}/${this.eventId}/getRegistrationTypeNames`)
      .query('environment', this.environment)
      .query('eventVersion', this.eventSnapshotVersion)
      .get()
      .build();
    const response = await fetchAndRetryIfServerBusy(request);
    if (!response.ok) {
      throw await ServiceError.create('getRegistrationTypeNames failed', response, request);
    }
    const registrationTypeNames = await response.json();
    return registrationTypeNames;
  }
}
